module.exports = __webpack_public_path__ + "static/solution-eac47e94973d059306f7ee0ec64c8213.png";